// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateProductSize_createButton__3nH31"};